<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data: () => ({ isLoaded: false }),
  mounted() {
    this.isLoaded = true;
  }
};
</script>

<style>
@import "./assets/css/app.css";
@import "./assets/css/fonts.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/* width */
::-webkit-scrollbar {
  width: 0.5vw;
}

/* Track */
::-webkit-scrollbar-track {
  background: #0099ff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ffffff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.8);
}

textarea:focus,
input:focus {
  outline: none;
}
</style>
